import angular, { IFilterService } from 'angular';

BasePriceFilterFactory.$inject = ['$filter'];

export function BasePriceFilterFactory($filter: IFilterService) {
  const filterCurrency = $filter('currency');

  function basePriceFilter(rawValue: string | number | null | undefined) {
    if (rawValue == null) {
      return null;
    }

    if (typeof rawValue === 'string' && rawValue === '') {
      return null;
    }

    const value = Number(rawValue);

    return filterCurrency(value);
  }

  return basePriceFilter;
}

export const BasePriceFilterModule = angular
  .module('acme.common.filter.basePrice', [])
  .filter('basePrice', BasePriceFilterFactory).name;

export function BasePriceIfNumberFilterFactory($filter: IFilterService) {
  const filterCurrency = $filter('currency');

  function basePriceIfNumberFilter(rawValue: string | number | null | undefined) {
    if (rawValue == null) {
      return null;
    }

    const normalizedBasePrice = rawValue === '' ? null : rawValue;

    if (normalizedBasePrice === null) {
      return null;
    }

    if (isNaN(Number(normalizedBasePrice))) {
      return rawValue;
    }

    const value = Number(normalizedBasePrice);

    return filterCurrency(value);
  }

  return basePriceIfNumberFilter;
}

export const BasePriceIfNumberFilterModule = angular
  .module('acme.common.filter.basePriceIfNumber', [])
  .filter('basePriceIfNumber', BasePriceIfNumberFilterFactory).name;
